import gqlTagGira from 'graphql-tag';

export const GOALS_FRAGMENT = gqlTagGira`
    fragment JiraGoalsFieldFragment on JiraGoalsField {
        __typename
        fieldId
        name
        fieldConfig {
            isEditable
        }
        selectedGoals(first: 1) {
            totalCount,
            edges {
                node {
                    id
                    name
                    status
                }
            }
        }
    }
`;
